import { render } from "./ShiftCalendar.vue?vue&type=template&id=208b35a5&scoped=true"
import script from "./ShiftCalendar.vue?vue&type=script&lang=js"
export * from "./ShiftCalendar.vue?vue&type=script&lang=js"

import "./ShiftCalendar.vue?vue&type=style&index=0&id=208b35a5&scoped=true&lang=css"
import "./ShiftCalendar.vue?vue&type=style&index=1&id=208b35a5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208b35a5"]])

export default __exports__